import React, { Component } from 'react'
import { Input, Label, FormGroup } from 'reactstrap';
import compact from 'lodash/compact';

const splitStrToLines = (str, lines) => {
  const split = str.split(/\n|\r/g);
  let res = [];
  for (let i = 0; i < lines; i +=1) {
    res[i] = split[i] || ""
  };

  return res;
}

class TextInput extends Component {
  constructor(props) {
    super(props);
    const { element, linesConfig } = props;

    this.state = {
      lines: splitStrToLines(element.textProperty.data.d.k[0].s.t, linesConfig.length),
    }
  }

  onChange = (event) => {
    const { value, name } = event.target;
    const { element } = this.props;
    const newLines = [...this.state.lines];
    newLines[name] = value;
    const change = compact(newLines).length - compact(this.state.lines).length;
    this.setState({ lines: newLines })
    this.props.onChange(compact(newLines).join("\r"), element, change);
  }

  render() {
    const { element, onTextInputFocus, linesConfig, onTextInputBlur } = this.props;
    const charsPerLine = linesConfig[0];
    return (
      <FormGroup>
        <Label for={element.data.nm}><strong>{element.data.nm}</strong> <small>({charsPerLine} chars. per line)</small></Label>
        {
          this.state.lines.map((val, index) => (
            <Input
              value={val}
              bsSize="sm"
              className="mb-1"
              maxLength={linesConfig[index]}
              key={`${element.data.nm}-line-${index}`}
              label={element.data.nm}
              name={index}
              onFocus={() => onTextInputFocus(element)}
              onBlur={() => onTextInputBlur(element)}
              onChange={this.onChange}
            />
          ))
        }
      </FormGroup>
    )
  }
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/TextInput.js